import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '../assets/company_logo.png'
import _imports_1 from '../assets/provider_icon.png'
import _imports_2 from '../assets/provider_logo.png'


const _hoisted_1 = { class: "home container" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "col-sm-6 offset-sm-3" }, [
  /*#__PURE__*/_createVNode("img", {
    alt: "Company Logo",
    src: _imports_0
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "col-sm-6 offset-sm-3" }, [
  /*#__PURE__*/_createVNode("img", {
    alt: "Provider Icon",
    src: _imports_1
  }),
  /*#__PURE__*/_createVNode("img", {
    alt: "Provider Logo",
    src: _imports_2
  })
], -1)
const _hoisted_5 = {
  key: 1,
  class: "row"
}
const _hoisted_6 = { class: "col col-md-6" }
const _hoisted_7 = /*#__PURE__*/_createVNode("h2", null, "Alerts", -1)
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table" }
const _hoisted_10 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", {
      scope: "col",
      style: {"width":"30%"}
    }, "Message"),
    /*#__PURE__*/_createVNode("th", {
      scope: "col",
      style: {"width":"5%"}
    }, "Status"),
    /*#__PURE__*/_createVNode("th", {
      scope: "col",
      style: {"width":"30%"}
    }, "Duration"),
    /*#__PURE__*/_createVNode("th", {
      scope: "col",
      style: {"width":"30%"}
    }, "Opened")
  ])
], -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  colspan: "3"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = /*#__PURE__*/_createVNode("h2", null, "Receiver stats", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReceiverStatsDisplay = _resolveComponent("ReceiverStatsDisplay")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.haveStatsOrAlerts())
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("div", _hoisted_8, [
              _createVNode("table", _hoisted_9, [
                _hoisted_10,
                _createVNode("tbody", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.receiverAlerts.items, (event) => {
                    return (_openBlock(), _createBlock("tr", {
                      key: event.id,
                      class: 
                  'table-' +
                  (event.Condition == 'closed' ? 'light' : 
                    event.Condition == 'instant' ? 'warning': 'danger'
                  )
                
                    }, [
                      (event.Condition != 'instant')
                        ? (_openBlock(), _createBlock("td", _hoisted_11, [
                            _createTextVNode(_toDisplayString(event.Message), 1),
                            (event.Data)
                              ? (_openBlock(), _createBlock("span", _hoisted_12, " (" + _toDisplayString(event.Data) + ")", 1))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createBlock("td", _hoisted_13, [
                            _createTextVNode(_toDisplayString(event.Message), 1),
                            (event.Data)
                              ? (_openBlock(), _createBlock("span", _hoisted_14, " (" + _toDisplayString(_ctx.renderInstantAlertData(event.Data)) + ")", 1))
                              : _createCommentVNode("", true)
                          ])),
                      (event.Condition != 'instant')
                        ? (_openBlock(), _createBlock("td", _hoisted_15, _toDisplayString(event.Condition), 1))
                        : _createCommentVNode("", true),
                      (event.Condition != 'instant')
                        ? (_openBlock(), _createBlock("td", _hoisted_16, [
                            (event.ClosingEvent)
                              ? (_openBlock(), _createBlock("span", _hoisted_17, _toDisplayString(_ctx.getHumanDateDiff(
                        event.Generated,
                        event.ClosingEvent.Generated
                      )) + " (" + _toDisplayString(_ctx.getHumanDate(event.ClosingEvent.Generated)) + ")", 1))
                              : (_openBlock(), _createBlock("span", _hoisted_18, _toDisplayString(_ctx.getHumanDateDiff(event.Generated)), 1))
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("td", null, _toDisplayString(_ctx.getHumanDateOffset(event.Generated)) + " (" + _toDisplayString(_ctx.getHumanDate(event.Generated)) + ") ", 1)
                    ], 2))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_19, [
            _hoisted_20,
            (_ctx.receiverStats.alerts)
              ? (_openBlock(), _createBlock(_component_ReceiverStatsDisplay, {
                  key: 0,
                  receiverStats: _ctx.receiverStats
                }, null, 8, ["receiverStats"]))
              : _createCommentVNode("", true)
          ])
        ]))
  ]))
}